module.exports = __webpack_public_path__ + "img/arraw.2bc12e86.png";